import "./drawerStats.css";

const MONTHS = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11,
};

const FLOW_LABELS = {
  application_start: "Registration opens",
  application_end: "Registration closes",
  registration_deadline: "Registration deadline",
  early_sif_deadline: "Aptitude forms close",
  open_evening: "Open evening",
  stage1_exam: "Stage 1 exam",
  stage1_result: "Stage 1 results",
  caf_deadline: "Council form closes",
  stage2_exam: "Stage 2 exam",
  stage2_result: "Stage 2 results",
  offered_day: "Offer day",
  appeal_deadline: "Appeal deadline",
};

function monthIndex(token) {
  return MONTHS[String(token || "").slice(0, 3).toLowerCase()];
}

/** Read a date out of the stored sentence. Unparsed rows keep their existing order. */
function parseLooseDate(text) {
  const t = String(text || "");
  const day = t.match(
    /(\d{1,2})\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\s+(\d{4})/i
  );
  if (day && monthIndex(day[2]) != null) {
    return new Date(Number(day[3]), monthIndex(day[2]), Number(day[1])).getTime();
  }
  const mid = t.match(/Mid\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\s+(\d{4})/i);
  if (mid && monthIndex(mid[1]) != null) {
    return new Date(Number(mid[2]), monthIndex(mid[1]), 15).getTime();
  }
  const month = t.match(/\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\s+(\d{4})/i);
  if (month && monthIndex(month[1]) != null) {
    return new Date(Number(month[2]), monthIndex(month[1]), 1).getTime();
  }
  return null;
}

function ordered(rows) {
  return rows
    .map((row, index) => ({ row, index, at: parseLooseDate(row.value) }))
    .sort((a, b) => {
      if (a.at == null && b.at == null) return a.index - b.index;
      if (a.at == null) return 1;
      if (b.at == null) return -1;
      return a.at - b.at;
    })
    .map((item) => item.row);
}

export default function KeyDateFlow({ rows }) {
  const steps = ordered(rows);
  if (!steps.length) return null;

  return (
    <ol className="ds-flow" aria-label="Key dates in order">
      {steps.map((step, index) => (
        <li className="ds-flow-step" key={step.key}>
          <span className="ds-flow-node" aria-hidden="true">
            {index + 1}
          </span>
          <div className="ds-flow-card">
            <div className="ds-flow-label">{FLOW_LABELS[step.key] || step.label}</div>
            <div className="ds-flow-value">{step.value}</div>
          </div>
        </li>
      ))}
    </ol>
  );
}
